import { ASSIGN_TEMPLATE, REMOVE_TEMPLATE } from "../../constants/ActionTypes";

export function AssignTemplateToDoc(values) {
  return (dispatch) => dispatch({ type: ASSIGN_TEMPLATE, payload: values });
}

export function RemoveTemplateFromDoc(values) {
  return (dispatch) => dispatch({ type: REMOVE_TEMPLATE, payload: values });
}
